/* EditMusicVideo.js */

import React, { useCallback, useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
// import AppBar1 from '../../components/commom/AppBar1';
import Footer1 from '../../components/commom/Footer1';
import MusicVideoForm from '../../components/remix/MusicVideoForm';
import { useAuth } from '../../context/auth/AuthContext';
import PSO from '../../services/PSO';
import Strings from '../../translations/Translations';
import AppBar2 from '../../components/commom/AppBar2/AppBar2';

export default function EditMusicVideo() {
  const history = useHistory();
  const { rid } = useParams();
  const { authenticated } = useAuth();

  const [remixPars, setRemixPars] = useState();
  const [remixStyle, setRemixStyle] = useState();

  const callBackAfterCreation = () =>  history.push('/dashboard');

  const getRemixPars = useCallback(async () => {
    if (rid) {
      try {
        const response = await PSO.getRemixPars({ un: authenticated.un, al: authenticated.al, rid, getappelements: 1});
        if (response.result === 'success') {
          if (response.its && response.its.length > 0) {
            setRemixPars(response.its[0]);
          }
          if (response.getRemixApprovedElements && response.getRemixApprovedElements.its_styles && response.getRemixApprovedElements.its_styles.length > 0) {
            setRemixStyle(response.getRemixApprovedElements.its_styles[0]);
          }
        }
      } catch (err) {
        toast.error(Strings('error_on_getting_parameters'));
        console.error(Strings('error_on_getting_parameters'));
      }
    }
  }, [rid, authenticated, setRemixPars, setRemixStyle]);
  useEffect(() => { getRemixPars(); }, [getRemixPars]);
  
  return (
    <>

      <AppBar2 />

      <MusicVideoForm
        openTinyPageAfterCreation={true}
        callBackAfterCreation={callBackAfterCreation}
        editMode
        remixPars={remixPars}
        remixStyle={remixStyle}
      />

      <Footer1 />

    </>
  );
}
